import { render, staticRenderFns } from "./ContactPersonForm.vue?vue&type=template&id=373e855d&scoped=true&"
import script from "./ContactPersonForm.vue?vue&type=script&lang=js&"
export * from "./ContactPersonForm.vue?vue&type=script&lang=js&"
import style0 from "./ContactPersonForm.vue?vue&type=style&index=0&id=373e855d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "373e855d",
  null
  
)

export default component.exports